import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

// Shares today's deal (id + live sold count) app-wide so product cards can show a
// "sold today" urgency badge without each one hitting the API.
const DealContext = createContext({ dealId: null, claimed: 0, allocation: 0 });
export const useDeal = () => useContext(DealContext);

export function DealProvider({ children }) {
  const [deal, setDeal] = useState({ dealId: null, claimed: 0, allocation: 0 });
  useEffect(() => {
    const load = () => api.get("/deal-of-day").then(({ data }) => {
      const d = data.deal;
      setDeal(d ? { dealId: d.id, claimed: d.claimed || 0, allocation: d.allocation || 0 }
                : { dealId: null, claimed: 0, allocation: 0 });
    }).catch(() => {});
    load();
    const i = setInterval(load, 30000);
    return () => clearInterval(i);
  }, []);
  return <DealContext.Provider value={deal}>{children}</DealContext.Provider>;
}
